import { PORTAL_NAV } from '../nav'
import { Shell } from './Shell'

/** Powłoka portalu pracownika (`/me/*`) — spec 03, 9 zakładek + asystent. */
export function PortalShell() {
  return (
    <Shell
      navNamespace="portalNav"
      items={PORTAL_NAV}
      contextSwitch={{ to: '/app', labelKey: 'shell.toCompany' }}
      fallbackMetaKey="portal"
      assistantScope="portal"
      variant="portal"
    />
  )
}
